<div class="partner-statistic">
    <pf-loading-overlay />
    <div class="partner-statistic__filters">
        <form
            action="statistics_filters"
            class="partner-statistic__filter-form"
            [formGroup]="productStatisticsFilter"
            (submit)="updateStockingStatisticsByFilter()"
        >
            <div class="partner-statistic__filter-field">
                <label for="product-event-partners">{{ 'admin.product.statistics.field.partnerName' | translate }}:</label>
                <pf-select
                    [options]="partnerOptions"
                    [multiMode]="true"
                    [initialSelectedIds]="savedPartnerIds()"
                    (selectionChange)="onPartnerIdsChange($event)"
                />
            </div>
            <div class="partner-statistic__filter-field">
                <label for="product-event-start-date">{{ 'admin.product.statistics.field.startDate' | translate }}:</label>
                <pf-datepicker
                    [multiMode]="true"
                    [initialStartDate]="savedStartDate()"
                    [initialEndDate]="savedEndDate()"
                    [maxDate]="maxDate"
                    (selectedStartDate)="onStartDateChange($event)"
                    (selectedEndDate)="onEndDateChange($event)"
                />
            </div>
            <div class="partner-statistic__filter-field partner-statistic__filter-actions">
                <button class="partner-statistic__search-btn" type="submit">
                    <mat-icon>search</mat-icon>
                    <span>{{ 'admin.product.statistics.button.search' | translate }}</span>
                </button>
                <button class="partner-statistic__reset-btn" type="button" (click)="onResetFilters()">
                    <mat-icon>refresh</mat-icon>
                    <span>{{ 'PRODUCT_EVENTS.RESET_FILTERS' | translate }}</span>
                </button>
            </div>
        </form>
    </div>
    @if (partnerStatisticsList.partnerStatisticsList?.length) {
        @if (totalItems() > 0) {
            <pf-pagination
                [requestedPage]="page()"
                [requestedPageSize]="size()"
                [totalItems]="totalItems()"
                (pageChanged)="onPageChanged($event)"
            />
        }
        <div class="partner-statistic__grid-container">
            <div class="partner-statistic__grid">
                <div class="partner-statistic__grid-header">
                    <div class="partner-statistic__grid-column">
                        {{ 'admin.product.statistics.field.partnerName' | translate }}
                    </div>
                    <div class="partner-statistic__grid-column">{{ 'admin.product.statistics.partnerView.delegated' | translate }}</div>
                    <div class="partner-statistic__grid-column">
                        {{ 'admin.product.statistics.partnerView.soldFromDelegation' | translate }}
                    </div>
                    <div class="partner-statistic__grid-column">{{ 'admin.product.statistics.partnerView.returned' | translate }}</div>
                    <div class="partner-statistic__grid-column">{{ 'admin.product.statistics.partnerView.stock' | translate }}</div>
                </div>
                <div class="partner-statistic__grid-body">
                    @for (partner of partnerStatisticsList.partnerStatisticsList; track $index; let i = $index) {
                        <div
                            class="partner-statistic__grid-row"
                            [class.partner-statistic__grid-row--clickable]="partner.partnerProductDetailList?.length"
                            [class.partner-statistic__grid-row--selected]="selectedRowIndex() === i"
                            [tabindex]="partner.partnerProductDetailList?.length ? 0 : -1"
                            (click)="partner.partnerProductDetailList?.length ? selectRow(i) : null"
                            (keydown.enter)="partner.partnerProductDetailList?.length ? selectRow(i) : null"
                        >
                            <div class="partner-statistic__grid-cell">{{ partner.partnerName }}</div>
                            <div class="partner-statistic__grid-cell">{{ partner.delegatedQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="partner-statistic__grid-cell">
                                {{ partner.soldFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                            </div>
                            <div class="partner-statistic__grid-cell">
                                {{ partner.returnedFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                            </div>
                            <div class="partner-statistic__grid-cell">{{ partner.stockQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                        </div>
                        @if (partner.expanded && partner.partnerProductDetailList?.length) {
                            <div class="partner-statistic__expanded" tabindex="0">
                                @if (partner.partnerProductDetailList) {
                                    <div class="partner-statistic__product-details">
                                        <div class="partner-statistic__expanded-title">
                                            <mat-icon>library_books</mat-icon>
                                            <span>{{ 'admin.product.statistics.detail.perProductTitle' | translate }}</span>
                                        </div>
                                        <div class="partner-statistic__grid">
                                            <div class="partner-statistic__grid-header">
                                                <div class="partner-statistic__grid-column">
                                                    {{ 'admin.product.statistics.field.productName' | translate }}
                                                </div>
                                                <div class="partner-statistic__grid-column">
                                                    {{ 'admin.product.statistics.partnerView.delegated' | translate }}
                                                </div>
                                                <div class="partner-statistic__grid-column">
                                                    {{ 'admin.product.statistics.partnerView.soldFromDelegation' | translate }}
                                                </div>
                                                <div class="partner-statistic__grid-column">
                                                    {{ 'admin.product.statistics.partnerView.returned' | translate }}
                                                </div>
                                                <div class="partner-statistic__grid-column">
                                                    {{ 'admin.product.statistics.partnerView.stock' | translate }}
                                                </div>
                                            </div>
                                            <div class="partner-statistic__grid-body">
                                                @for (product of partner.partnerProductDetailList; track $index) {
                                                    <div class="partner-statistic__grid-row partner-statistic__grid-row--detail">
                                                        <div class="partner-statistic__grid-cell">{{ product.productName }}</div>
                                                        <div class="partner-statistic__grid-cell">
                                                            {{ product.delegatedQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="partner-statistic__grid-cell">
                                                            {{ product.soldFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="partner-statistic__grid-cell">
                                                            {{ product.returnedFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="partner-statistic__grid-cell">
                                                            {{ product.stockQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
        @if (totalItems() > 0) {
            <pf-pagination
                [requestedPage]="page()"
                [requestedPageSize]="size()"
                [totalItems]="totalItems()"
                (pageChanged)="onPageChanged($event)"
            />
        }
        <div class="partner-statistic__totals">
            <div class="partner-statistic__total-card">
                <mat-icon>approval_delegation</mat-icon>
                <span>{{ 'admin.product.statistics.partnerView.totalDelegated' | translate | uppercase }}</span>
                <div class="partner-statistic__total-value">{{ totals()?.delegated | number: '1.0-0' : 'hu-HU' }}</div>
            </div>
            <div class="partner-statistic__total-card">
                <mat-icon>money_bag</mat-icon>
                <span>{{ 'admin.product.statistics.partnerView.totalSoldFromDelegation' | translate | uppercase }}</span>
                <div class="partner-statistic__total-value">
                    {{ totals()?.soldFromDelegation | number: '1.0-0' : 'hu-HU' }}
                </div>
            </div>
            <div class="partner-statistic__total-card">
                <mat-icon>arrow_circle_left</mat-icon>
                <span>{{ 'admin.product.statistics.partnerView.totalReturned' | translate | uppercase }}</span>
                <div class="partner-statistic__total-value">{{ totals()?.returned | number: '1.0-0' : 'hu-HU' }}</div>
            </div>
            <div class="partner-statistic__total-card">
                <mat-icon>warehouse</mat-icon>
                <span>{{ 'admin.product.statistics.partnerView.totalStock' | translate | uppercase }}</span>
                <div class="partner-statistic__total-value">{{ totals()?.stock | number: '1.0-0' : 'hu-HU' }}</div>
            </div>
        </div>
    }
</div>
